import { createSlice } from "@reduxjs/toolkit";
import { checkUserSessionAction, addLogIn } from "./signIn.action";


const initialState = {
    login: {},
    loginLoading: false,
    loginLoadingSucess: false,
    loginLoadingFailed: false,
    error: "",
    isSessionLoading: false,
    isSessionLoadingFailed: false,
    isAuthenticated: false,
  };
  
  const loginSlicer = createSlice({
    name: "login/signIn",
    initialState: initialState,
    reducers: {
      removeToken: (state) => {
        localStorage.removeItem("AdminHeaven");
        state.login = {};
        state.loginLoading = false;
        state.loginLoadingSucess = false;
        state.isAuthenticated = false;
      },
      resetState: (state) => {
        state.login = {};
        state.loginLoading = false;
        state.loginLoadingSucess = false;
        state.isAuthenticated = false;
      },
    },
    extraReducers: {
      [addLogIn.pending]: (state) => {
        state.loginLoading = true;
        state.loginLoadingFailed = false;
        state.loginLoadingSucess = false;
        state.error = "";
      },
      [addLogIn.fulfilled]: (state, action) => {
        state.loginLoading = false;
        state.loginLoadingSucess = true;
        state.loginLoadingFailed = false;
        state.isAuthenticated = true;
        state.login = action.payload || {};
        state.error = "";
      },
      [addLogIn.rejected]: (state, action) => {
        state.loginLoading = false;
        state.loginLoadingFailed = true;
        state.loginLoadingSucess = false;
        state.error = action.payload || action.error?.message || "Login failed";
        state.isAuthenticated = false;
      },
      [checkUserSessionAction.pending]: (state) => {
        state.isSessionLoading = true;
        state.isSessionLoadingFailed = false;
      },
      [checkUserSessionAction.fulfilled]: (state, action) => {
        state.isAuthenticated = true;
        state.isSessionLoading = false;
        state.login = action.payload || {};
        state.error = "";
      },
      [checkUserSessionAction.rejected]: (state, action) => {
        state.isSessionLoading = false;
        state.isSessionLoadingFailed = true;
        state.isAuthenticated = false;
        state.login = {};
        state.error = action.payload || action.error?.message || "";
        localStorage.removeItem("AdminHeaven");
      },
    },
  });
  
  export const { removeToken, resetState } = loginSlicer.actions;
  
  export default loginSlicer.reducer;



// import { createSlice } from "@reduxjs/toolkit";
// import { checkUserSessionAction, addLogIn } from "./signIn.action";

// const initialState = {
//   login: {},
//   loginLoading: false,
//   loginLoadingSuccess: false,
//   loginLoadingFailed: false,
//   error: null,
//   isSessionLoading: false,
//   isAuthenticated: false,
// };

// const loginSlicer = createSlice({
//   name: "login/signIn",
//   initialState,
//   reducers: {
//     removeToken: (state) => {
//       localStorage.removeItem("AdminHeaven");
//       state.login = {};
//       state.loginLoading = false;
//       state.loginLoadingSuccess = false;
//       state.isAuthenticated = false;
//     },
//     resetState: (state) => {
//       state.login = {};
//       state.loginLoading = false;
//       state.loginLoadingSuccess = false;
//       state.isAuthenticated = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(addLogIn.pending, (state) => {
//         state.loginLoading = true;
//         state.error = null;
//       })
//       .addCase(addLogIn.fulfilled, (state, action) => {
//         state.loginLoading = false;
//         state.loginLoadingSuccess = true;
//         state.isAuthenticated = true;
//         state.login = action.payload;
//         state.error = null;
//       })
//       .addCase(addLogIn.rejected, (state, action) => {
//         state.loginLoading = false;
//         state.loginLoadingFailed = true;
//         state.isAuthenticated = false;
//         state.error = action.error.message || "Login failed";
//       })
//       .addCase(checkUserSessionAction.pending, (state) => {
//         state.isSessionLoading = true;
//         state.isAuthenticated = false;
//       })
//       .addCase(checkUserSessionAction.fulfilled, (state, action) => {
//         state.isAuthenticated = true;
//         state.isSessionLoading = false;
//         state.login = action.payload;
//         state.error = null;
//       })
//       .addCase(checkUserSessionAction.rejected, (state) => {
//         state.isSessionLoading = false;
//         state.isAuthenticated = false;
//       });
//   },
// });

// export const { removeToken, resetState } = loginSlicer.actions;

// export default loginSlicer.reducer;